import { init as initReact } from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'

import { environment } from './environment'

export const configureSentry = (): void => {
  if (environment.sentryDsn !== undefined) {
    const initOptions = {
      dsn: environment.sentryDsn,
      tracesSampleRate: 1,
      release: environment.release,
      dist: environment.dist,
      environment: environment.name
    }
    initReact({ ...initOptions, integrations: [new BrowserTracing()] })
  }
}
